import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import '@/assets/scss/global.scss'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueTooltip from 'v-tooltip'
import VueModal from '@/plugins/Modal'

let mapApiKey = ''

if (process.env.CONTEXT === 'production') {
  mapApiKey = process.env.MAP_API_KEY
}
if (process.env.CONTEXT === 'deploy-preview') {
  mapApiKey = process.env.MAP_API_KEY_PREPROD
}
if (process.env.CONTEXT === 'branch-deploy') {
  mapApiKey = process.env.MAP_API_KEY_PREPROD
}

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: mapApiKey,
    libraries: 'geometry',
  },
})
Vue.use(VueTooltip)
Vue.use(VueModal)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#gtr-radar')
